<section class="dialog-shell">
  <header class="dialog-shell__header">
    <div class="dialog-shell__heading">
      <h2 class="dialog-shell__title">{{ title() }}</h2>
      @if (subtitle()) {
        <p class="dialog-shell__subtitle">{{ subtitle() }}</p>
      }
    </div>
    <button
      mat-icon-button
      type="button"
      class="dialog-shell__close"
      aria-label="Close dialog"
      (click)="close()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="dialog-shell__body">
    <ng-content></ng-content>
  </div>
  <footer class="dialog-shell__actions" [class.dialog-shell__actions--muted]="mutedFooter()">
    <ng-content select="[actions]"></ng-content>
  </footer>
</section>
